import { select } from 'redux-saga/effects'

/* eslint-disable import/prefer-default-export */

export function* shouldCallJerseyName({ query, brandName, gender }) {
	const state = yield select()
	return yield state.jerseyNameSuggestionsFetchQuery !== query || state.jerseyNameSuggestionsFetchBrandName !== brandName || state.jerseyNameSuggestionsFetchGender !== gender
}



// WEBPACK FOOTER //
// ./src/redux/saga/search/sagas.js